import { useEffect, useState } from "react";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _ThirdBankingAccount } from "../../../../../../core/services/dataBean/EntityCatalog";
import { BasicTable } from "../../../../../theme/Component/BasicTable";
import { ThirdBankingAccount } from "../../../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBankingAccount";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { toast } from "react-toastify";

interface ProcedureFunctions {
    _procedure: any;
    _pocessData?: any;
    _exportMap: Function;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const SO003 = ({ configProcedure }: Props) => {

    const [props, setProps] = useState<any>({});
    const [bean, setBean] = useState<any>({});

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData]);

    const onExportMap = () => {
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(`Se selecciono el proveeodor ${bean.EntityName}`)
        }

        if (configProcedure?._pushProps) {
            configProcedure?._pushProps({ IDAccount: bean.IDAccount });
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(bean);
        }
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <AccountEditor idAccount={bean.IDAccount} label="Proveedor Seleccionado" onChange={(e) => { setBean(e); console.log(e) }} />
            </div>
            {bean.IDAccount &&
                <>
                    <div className="col-md-12">
                        <ThirdBankingAccount canModify isModal idAccount={bean.IDAccount} />
                    </div>
                </>
            }
            <div className="col-md-12">
                <BasicButton eventClick={() => {
                    if (bean.IDAccount) {
                        onExportMap()
                    } else {
                        toast.error("Debe seleccionar un Proveedor")
                    }
                }} icon="ri-send-plane-line" >Seleccionar</BasicButton>
            </div>
        </div>
    )
}